// extracted by mini-css-extract-plugin
export default {"container":"OjkszV","thumbnail":"XPEMCH","overlay":"_8tAyR","button":"Ym4kNx","arrow":"wM0E5k","icon":"bg3nLo"};